import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';
import {
    TextFill,
    tfmixin
} from './vue/components/text-fill/TextFill.vue';
import lazyload from './features/lazy-load';
lazyload();
const mixins = [tfmixin];
initMain(mixins, {
    TextFill,
    TrendsHorizontal: () => import('./vue/components/trends/TrendsHorizontal.vue')
}, []);
header();